import { render } from "./StaffAccess.vue?vue&type=template&id=f12f4340&ts=true"
import script from "./StaffAccess.vue?vue&type=script&lang=ts"
export * from "./StaffAccess.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__